import { useQuery } from '@tanstack/react-query';
import { getFetch } from '@legacy/utils/fetcher';
import { IFeatureEntity } from '../types';
import { GET_FEATURES_KEY } from '../const';

const GET_FEATURES_URL_PATH = '/api/v2/features';
export const GET_FEATURE_MSW_STATUS_KEY = 'getFeatureAPI';

const getFeature = (id: number): Promise<IFeatureEntity> =>
  getFetch({
    path: `${GET_FEATURES_URL_PATH}/${id}`,
    key: GET_FEATURE_MSW_STATUS_KEY,
  });

export const useGetFeature = (id: number) => {
  const { data, ...rest } = useQuery({
    queryKey: [GET_FEATURES_KEY, id],
    queryFn: () => getFeature(id),
    refetchOnMount: false,
  });

  return {
    name: data?.properties.name,
    identifier: data?.properties.identifier,
    isActive: data?.properties.enabled,
    ...rest,
  };
};
